import { render, staticRenderFns } from "./BackdropOverlay.vue?vue&type=template&id=36e637c0&"
import script from "./BackdropOverlay.vue?vue&type=script&lang=ts&"
export * from "./BackdropOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports